import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'
import { Body } from './Body'
import { Header } from './Header'
import { Footer } from './Footer'

interface Props {
  dates: string[]
  multiTerritory: boolean
}

export function Content(props: Props) {
  const { dates, multiTerritory } = props
  const { ready } = useConfigureController(dates, multiTerritory)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />} minWidth={1030}>
      <Body />
    </ModalContent>
  )
}
